'use strict';

exports.__esModule = true;
exports.HooksManager = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HOOKS = {
  all: 'all',
  data: 'data'
};

var ALL_COMPS_TYPE = '*';

var HooksManager = exports.HooksManager = function () {
  function HooksManager() {
    _classCallCheck(this, HooksManager);

    this._hooks = {};
  }

  /**
   * Validate that the hook name is correct
   * @param {String} hookName - hooks name
   */


  HooksManager.prototype.validateHookName = function validateHookName(hookName) {
    if (!HOOKS[hookName]) {
      throw 'Invalid Hook Name ' + hookName; //eslint-disable-line no-throw-literal
    }
  };

  /**
   * Unregister all hooks.
   */


  HooksManager.prototype.unregisterAllHooks = function unregisterAllHooks() {
    this._hooks = {};
  };

  /**
   * Unregister only hooks that are passed
   * @param {Array} hooksToRemove - array of hooks names
   */


  HooksManager.prototype.unregisterHooks = function unregisterHooks(hooksToRemove) {
    var _this = this;

    _lodash2.default.forEach(hooksToRemove, function (hookName) {
      return delete _this._hooks[hookName];
    });
  };

  /**
   * Execute all callbacks of the specified hook for the specified component. if registered to all will trigger this as well
   * @param {String} RMI
   * @param {String} hookName The name of the hook to execute (i.e HOOKS.DATA).
   * @param {String} compType The component type or none to  hooks that were registered for all component types.
   * @param {String} compId
   * @param {Array?} args The arguments that will be passed to the hook callbacks.
   */


  HooksManager.prototype.executeHooksAndUpdateValue = function executeHooksAndUpdateValue(RMI, hookName, compType, compId, args) {
    function executeTypeHook(hooks) {
      var _this2 = this;

      if (!hooks) {
        return;
      }
      var hooksForCompType = hooks[compType] || [];
      var hooksForAllCompType = hooks['*'] || [];
      _lodash2.default.forEach(hooksForCompType.concat(hooksForAllCompType), function (cb) {
        cb.apply(_this2, [RMI, hookName, compId].concat(args || []));
      });
    }

    var hook = this._hooks[hookName];
    var allPropsHooks = this._hooks[HOOKS.all];
    executeTypeHook(hook);
    executeTypeHook(allPropsHooks);
  };

  /**
   * Register callback to run the function specified in when executing the hook specified in the hookName parameter according to the hook name
   * @param {String} hookName The name of the hook to registered
   * Hook name can be specific prop or all for all props
   * @param {String?} compType The component type that will use the callback while running the operation according to the hookType. if no comp
   * will fire for all comps for the hooks name.
   * @param {function} callback function to execute.
    */


  HooksManager.prototype.registerHook = function registerHook(hookName, compType, callback) {
    this.validateHookName(hookName);
    if (!callback) {
      return;
    }

    var hook = this._hooks[hookName];
    if (!hook) {
      this._hooks[hookName] = hook = {};
    }

    compType = compType || ALL_COMPS_TYPE;
    var hookForComp = hook[compType];
    if (!hookForComp) {
      hook[compType] = hookForComp = [];
    }

    hookForComp.push(callback);
  };

  _createClass(HooksManager, [{
    key: 'HOOKS',
    get: function get() {
      return HOOKS;
    }
  }]);

  return HooksManager;
}();
//# sourceMappingURL=hooksManager.js.map